module.exports = __webpack_public_path__ + "static/media/21-speaker_profile.ebca95cc.webp";